import styled from 'react-emotion';

export const AulaEditorWrapper = styled('div')`
  ${({ readOnly }) => (readOnly ? 'opacity: 0.5;' : '')}

  // File Rename Box
  & [data-testid='rename-file-input'] {
    & p {
      min-width: 30px;
    }
  }
    
  //  Code Block
  & [data-testid='code-block'] {
    .language-undefined {
      white-space: break-spaces;
    }
  }

  & code[class*='language-'] {
    white-space: break-spaces !important;
  }

  // '+' icon
  & [data-testid='block-menu'] {
    padding-left: 8px;
  }

  // LaTeX Box
  & [data-slate-node='element'] {
    .katex-display {
      max-width: 50rem !important;
    }
  }

  // Boxes parent
  & [data-testid='root-element'] {
    width: 93% !important;
  }

  & [data-testid='latex-syntax'] {
    overflow: auto;
  }

  '& [data-testid="loading"]': {
    min-width: 150px,
    background-color: yellow
  },
`;

export default {};
